import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const CommonApi = createApi({
  reducerPath: "CommonApi",
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_API_HOST,
    prepareHeaders: (headers, { getState }) => {
      const token = getState().auth.token;

      // If we have a token set in state, let's assume that we should be passing it.
      if (token) {
        headers.set("authorization", `Bearer ${token}`);
      }
      return headers;
    },
  }),
  endpoints: (builder) => ({
    getCompanyList: builder.query({
      query: (data) => ({
        url: "get/companies/listing",
        method: "POST",
      }),
    }),
    getSkills: builder.query({
      query: (data) => ({
        url: "get/skills",
        method: "GET",
      }),
    }),
    getIdentity: builder.query({
      query: (data) => ({
        url: "get/identity",
        method: "GET",
      }),
    }),
    getCities: builder.query({
      query: (data) => ({
        url: "get/cities",
        method: "GET",
      }),
    }),
    getIndustries: builder.query({
      query: (data) => ({
        url: "get/industrials",
        method: "GET",
      }),
    }),
    uploadFile: builder.mutation({
      query: (file) => {
        const body = new FormData();
        body.append("Content-Type", file.type);
        body.append("file", file);
        return {
          url: "candidate/upload/registration",
          method: "POST",
          body: body,
        };
      },
    }),
    getPageData: builder.query({
      query: (slug) => ({
        url: "page/cms/" + slug,
        method: "GET",
      }),
    }),
    getCompanyDetail: builder.query({
      query: (id) => ({
        url: "get/companies/" + id,
        method: "GET",
      }),
    }),
    getFilterOptions: builder.query({
      query: (id) => ({
        url: "field/search",
        method: "GET",
      }),
    }),
    submitSubscribe: builder.mutation({
      query: (data) => {
        return {
          url: "submit/action/subscribe",
          method: "POST",
          body: data,
        };
      },
    }),
    getContactDetails: builder.query({
      query: () => {
        return {
          url: "get/setting",
        };
      },
    }),
    submitContact: builder.mutation({
      query: (data) => {
        return {
          url: "submit/action/contactus",
          method: "POST",
          body: data,
        };
      },
    }),
    getHomeBox: builder.query({
      query: () => {
        return {
          url: "field/search/homebox",
        };
      },
    }),
    getPhoneCode: builder.query({
      query: () => {
        return {
          url: "get/phonecodes",
        };
      },
    }),
    getRisePlans: builder.query({
      query: () => {
        return {
          url: "candidate/plans",
        };
      },
    }),
    getPlanPartner: builder.query({
      query: (data) => {
        return {
          url: "candidate/recruiter-history-by-plan",
          method: "POST",
          body: data,
        };
      },
    }),
  }),
});

export const {
  useGetCompanyListQuery,
  useGetCitiesQuery,
  useGetIdentityQuery,
  useGetSkillsQuery,
  useUploadFileMutation,
  useGetPageDataQuery,
  useGetIndustriesQuery,
  useGetCompanyDetailQuery,
  useGetFilterOptionsQuery,
  useSubmitSubscribeMutation,
  useGetContactDetailsQuery,
  useSubmitContactMutation,
  useGetHomeBoxQuery,
  useGetPhoneCodeQuery,
  useGetRisePlansQuery,
  useGetPlanPartnerQuery,
} = CommonApi;
